import React from "react";
import {

    Bar,
   ComposedChart,  Legend, Line,  XAxis
} from "recharts";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";


const mock = [
    {
        "data": "2023-12-04T00:00:00.000Z",
        "dia": 4,
        "numCiclos": 26,
        "numCiclos40SegValidos": 25,
        "segundosIniAFim": 6832,
        "tempoCiclo": 6217,
        "tempoEsperaOper": 1522,
        "EnergiakWh": 0
    },
    {
        "data": "2023-12-05T00:00:00.000Z",
        "dia": 5,
        "numCiclos": 16,
        "numCiclos40SegValidos": 13,
        "segundosIniAFim": 3617,
        "tempoCiclo": 3314,
        "tempoEsperaOper": 602,
        "EnergiakWh": 0
    },
    {
        "data": "2023-12-06T00:00:00.000Z",
        "dia": 6,
        "numCiclos": 16,
        "numCiclos40SegValidos": 15,
        "segundosIniAFim": 4430,
        "tempoCiclo": 4238,
        "tempoEsperaOper": 1236,
        "EnergiakWh": 0
    },
    {
        "data": "2023-12-07T00:00:00.000Z",
        "dia": 7,
        "numCiclos": 16,
        "numCiclos40SegValidos": 14,
        "segundosIniAFim": 3511,
        "tempoCiclo": 3300,
        "tempoEsperaOper": 671,
        "EnergiakWh": 0
    },
    {
        "data": "2023-12-11T00:00:00.000Z",
        "dia": 11,
        "numCiclos": 28,
        "numCiclos40SegValidos": 28,
        "segundosIniAFim": 6525,
        "tempoCiclo": 6268,
        "tempoEsperaOper": 1411,
        "EnergiakWh": 0
    },
    {
        "data": "2023-12-12T00:00:00.000Z",
        "dia": 12,
        "numCiclos": 14,
        "numCiclos40SegValidos": 14,
        "segundosIniAFim": 3128,
        "tempoCiclo": 2996,
        "tempoEsperaOper": 569,
        "EnergiakWh": 0
    },
    {
        "data": "2023-12-13T00:00:00.000Z",
        "dia": 13,
        "numCiclos": 15,
        "numCiclos40SegValidos": 15,
        "segundosIniAFim": 3503,
        "tempoCiclo": 3376,
        "tempoEsperaOper": 484,
        "EnergiakWh": 0
    },
    {
        "data": "2023-12-14T00:00:00.000Z",
        "dia": 14,
        "numCiclos": 15,
        "numCiclos40SegValidos": 13,
        "segundosIniAFim": 3003,
        "tempoCiclo": 2823,
        "tempoEsperaOper": 375,
        "EnergiakWh": 0
    }
]

const ProducaoNoTempoChart = (props) => {

    const  data  = props.data? props.data : mock;

    const width = props.width? props.width : 300;
    const height = props.height? props.height : 300;
    const titulo = props.titulo? props.titulo : 'TITULO';
    const dataKeyX = props.dataKeyX? props.dataKeyX : "dia";
    const axisX = props.axisX? props.axisX : false;
    const maxBarSize = props.maxBarSize? { maxBarSize: props.maxBarSize} : {}
    const legenda = typeof(props.legenda) !== "undefined"? props.legenda : true;


    // <Grid  style={{backgroundColor: "green", width: width, heigth: height }}>

    //      <Grid>

    const calcTempoUso = data => {
        let x = data.tempoCiclo / 60 /60;
        x = Math.round(x * 10) / 10;
        return (x);
    }


    return(
        <Grid container item style={{backgroundColor: "white", width: width, height: height }}>
            <Grid container item justifyContent={"center"}>
                <Typography>{titulo}</Typography>
            </Grid>
            <Grid item style={ {width: "100%", height: "100%", padding: 10}}>


                     <ComposedChart
                        width={width}
                        height={height-30}
                        data={data}
                        margin={{
                            top: 15,
                            right: 30,
                            left: 0,
                            bottom: 10,
                        }}
                    >

                        <XAxis dataKey={dataKeyX} tickLine={false} axisLine={axisX}/>
                         {legenda && <Legend/>}
                        <Bar type="monotone" isAnimationActive={false} name="Rasp. Válidas" data={data} {...maxBarSize} dataKey="numCiclos" fill="#a8adb3" label={{ position: 'botton', fill:'black' }} />
                        <Line type="monotone" isAnimationActive={false} yAxisId={1} name="Horas utilizadas" dataKey={calcTempoUso} label={{ position: 'top', fill: 'blue' }} />
                    </ComposedChart>

            </Grid>
        </Grid>
    );

}

export default ProducaoNoTempoChart;